<template>
  <div class="-page">
    <svg-icon
      id="guide-full"
      :icon="isFullScreen ? 'exit-fullscreen' : 'fullscreen'"
      @click="onToggleFullScreen"
    ></svg-icon>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import screenfull from 'screenfull'

const isFullScreen = ref(false)

const onToggleFullScreen = () => {
  screenfull.toggle()
}

// 监听到screenfull状态改变，会被调用
const change = () => {
  isFullScreen.value = screenfull.isFullscreen
}
onMounted(() => {
  screenfull.on('change', change)
})

onUnmounted(() => {
  // 组件销毁时，取消监听
  screenfull.off('change', change)
})
</script>

<style scoped lang="scss"></style>
